// extracted by mini-css-extract-plugin
module.exports = {"pricingTable":"index_pricingTable_2sRwf","pricingTableItem":"index_pricingTableItem_LQA4K"};